import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { CareTeamSlotAssignment } from '../../../../episodes/data/episodesApi'

export const useCareTeamProviderName = () => {
  const intl = useIntl()

  return useCallback(
    (assignment: CareTeamSlotAssignment): string =>
      assignment.display_name ||
      [assignment.first_name, assignment.last_name].filter(Boolean).join(' ') ||
      intl.formatMessage({
        defaultMessage: 'Unknown provider',
        description: 'Fallback name for a care team member whose provider profile is unavailable',
      }),
    [intl],
  )
}
